import { useEffect, useState } from "react";
import { getWorkpaper } from "../../apiClient/operations/selfServiceWorkflowOperations";

export function useWorkpaper({ workpaperId }) {

  const [workpapers, setWorkpapers] = useState(null);
  const [workpaperData, setWorkpaperData] = useState(null);

  const [isLoadingWorkpapers, setIsLoadingWorkpapers] = useState(false);
  const [errorWorkpapers, setErrorWorkpapers] = useState(false);

  const getTransformedData = (data) => {
    let workpapers = []
    if (data?.workpapers){
      workpapers = data?.workpapers?.map(workpaper => (
        {
          ...workpaper,
          ...(workpaper.document && {
            "document": {
              "bucket": workpaper.document.bucket,
              "key": workpaper.document.path
            }
          })
        }
      ))
    }

    let fiscal_documents = Object.keys(data?.fiscal_documents).map(document => ({
      "name": document,
      "status": data?.fiscal_documents?.[document]
    }))

    return {
      ...data,
      "fiscal_documents": fiscal_documents,
      "workpapers": workpapers
    }
  };

  const getWorkpapersFormatted = async () => {
    try {
      setIsLoadingWorkpapers(true);
      const response = await getWorkpaper(workpaperId);
      const transformedData = getTransformedData(response);
      setWorkpaperData(transformedData);
      setWorkpapers(transformedData?.workpapers);
    } catch (error) {
      console.log("GET Workpapers ERROR: ", error);
      setErrorWorkpapers(error.message);
    } finally {
      setIsLoadingWorkpapers(false);
    }
  };

  useEffect(() => {
    if (workpaperId) {
      getWorkpapersFormatted();
    }
  }, [workpaperId]);

  return {
    workpaperData,
    workpapers,
    isLoadingWorkpapers,
    errorWorkpapers,
  };
}
